<template>
  <div class="limit props-group">
    <el-form-item label="录入限制">
      <el-switch v-model="component.properties.limit.enable"></el-switch>
    </el-form-item>
    <el-form-item label="失焦校验">
      <el-checkbox v-model="component.properties.limit.triggerBlur"></el-checkbox>
    </el-form-item>
    <template v-if="component.properties.limit.enable">
      <transition-group name="limit-transition" tag='ul'>
        <template v-for="(rule, ruleindex) in component.properties.limit.rules">
          <div class="box" :key="rule.id">
            <el-form-item class="title" :label="'限制条件'+(component.properties.limit.rules.length - ruleindex)">
              <i class="el-icon-close" @click="deleteLimit(ruleindex)"></i>
            </el-form-item>
            <el-form-item label="限制类型">
              <el-select v-model="rule.limitType" class="select-type">
                <el-option label="字符数" value="字符数" :disabled="getLimitType.includes('字符数')"></el-option>
                <el-option v-if="component.archive.dataType==='varchar' || component.archive.dataType==='text'" label="字符格式" value="字符格式" :disabled="getLimitType.includes('字符格式')"></el-option>
                <el-option v-if="component.archive.dataType==='varchar' || component.archive.dataType==='text'" label="包含字符" value="包含字符" :disabled="getLimitType.includes('包含字符')"></el-option>
                <el-option v-if="component.archive.dataType==='decimal'" label="数值限制" value="数值限制" :disabled="getLimitType.includes('数值限制')"></el-option>
                <el-option v-if="component.archive.dataType==='date'" label="日期限制" value="日期限制" :disabled="getLimitType.includes('日期限制')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="限制条件"  prop="properties.limit.rules"
                          :rules=" { validator: validateLimit, options:rule}">
              <div v-if="rule.limitType==='包含字符'" class="rule-content">
                <!--字符包含-->
                <template v-for="(include, includeIndex) in rule.includeString">
                  <div :key="includeIndex">
                    <el-select v-model="include.type" class="select-type">
                      <el-option label="包含" value="contain"></el-option>
                      <el-option label="不包含" value="noContain"></el-option>
                    </el-select>
                    <i class="el-icon-plus" @click="addIncludeString(ruleindex)"></i>
                    <i class="el-icon-minus" @click="deleteIncludeString(ruleindex, includeIndex)"></i>
                    <el-input v-model="include.value"  class="select-type"></el-input>
                  </div>
                </template>
              </div>
              <div v-else-if="rule.limitType==='字符格式'" class="rule-content">
                <!--字符格式-->
                <el-select v-model="rule.stringFormat" class="select-type">
                  <el-option value="english" label="英文"/>
                  <el-option value="number" label="数字"/>
                  <el-option value="phoneNum" label="手机号"/>
                  <el-option value="english&number" label="英文+数字"/>
                  <el-option value="notChinese" label="非中文字符"/>
                  <el-option value="chinese" label="中文字符"/>
                </el-select>
              </div>
              <div v-else-if="rule.limitType !==''" class="rule-content">
                <!--最大最小值-->
                <el-input v-model="rule.min" placeholder="最小值" class="select-type"></el-input>
                <el-input v-model="rule.max" placeholder="最大值" class="select-type"></el-input>
                <!--日期控件待完善-->
                <!--<el-date-picker
                  v-model="rule.min"
                  type="date"
                  placeholder="最大日期">
                </el-date-picker>
                <el-date-picker
                  v-model="rule.max"
                  type="date"
                  placeholder="最小日期">
                </el-date-picker>-->
              </div>
            </el-form-item>
          </div>
          <p :key="ruleindex" class="addLimit" v-show="ruleindex === 0" @click="addLimit()"><b class="el-icon-plus"></b>&nbsp;&nbsp;添加限制</p>
        </template>
      </transition-group>
      <p class="addLimit" v-show="component.properties.limit.rules.length === 0" @click="addLimit()"><b class="el-icon-plus"></b>&nbsp;&nbsp;添加限制</p>
    </template>
  </div>
</template>

<script>
import {UUID} from '../../../plugins/common'

export default {
  name: 'attr-limit',
  props: ['component'],
  mounted () {

  },
  watch: {
    'component.properties.limit.enable' (val) {
      if (val) {
        if (!this.component.properties.limit.rules.length) {
          this.addLimit()
        }
      } else {
        this.component.properties.limit.rules = []
      }
    }
  },
  created () {
    // 手动增加id渲染用, 保存时删除
    this.component.properties.limit.rules.forEach(m => {
      if (!m.id) {
        m.id = UUID.create()
      }
    })
    this.component.properties.limit.rules.reverse() // 倒序取反
  },
  methods: {
    validateLimit  (rule, value, callback) {
      let m = rule.options
      if (m.limitType === '包含字符') {
        m.includeString.forEach(n => {
          if (n.value === '') {
            callback(new Error('缺少限制条件'))
          }
        })
      } else if (m.limitType === '字符格式') {
        if (m.stringFormat === '') {
          callback(new Error('缺少限制条件'))
        }
      } else {
        if (m.max === '' && m.min === '') {
          callback(new Error('缺少限制条件'))
        } else if (m.max !== '' && m.min !== '') {
          if (isNaN(m.max) || isNaN(m.min)) {
            callback(new Error('请输入数字'))
          } else if (Number(m.max) < Number(m.min)) {
            callback(new Error('最大值需大于最小值'))
          } else if (Number(m.min) < 0) {
            callback(new Error('最小值0'))
          } else if (Number(m.max) > 300) {
            callback(new Error('最大值为300'))
          }
        }
      }
      callback()
    },
    addLimit () {
      this.component.properties.limit.rules.unshift({'id': UUID.create(), 'limitType': '', 'min': '', 'max': '', 'stringFormat': '', 'includeString': [{'type': 'contain', 'value': ''}]})
    },
    deleteLimit (index) {
      this.component.properties.limit.rules.splice(index, 1)
      if (this.component.properties.limit.rules.length === 0) {
        this.component.properties.limit.enable = false
      }
    },
    addIncludeString (index) {
      let rule = this.component.properties.limit.rules[index]
      rule.includeString.push({'type': 'contain', 'value': ''})
    },
    deleteIncludeString (ruleindex, includeIndex) {
      let rule = this.component.properties.limit.rules[ruleindex]
      if (rule.includeString.length === 1) {
        this.deleteLimit(ruleindex)
      } else {
        rule.includeString.splice(includeIndex, 1)
      }
    }
  },
  computed: {
    getLimitType () {
      let useLimitType = []
      this.component.properties.limit.rules.forEach(m => {
        if (m.limitType !== '') {
          useLimitType.push(m.limitType)
        }
      })
      return useLimitType
    }
  }
}
</script>

<style lang="scss">
  .limit {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
    .title {
      margin: 0;
      i {
        float: right;
        line-height: 32px;
        color: #c2c3c4;
      }
      .el-form-item__label{
        color: #c2c3c4;
      }
    }
    .title::after {
      width: 100%;
      height: 1px;
      background: #c2c3c4;
      margin-bottom: 6px;
    }
    .box {
      border: 1px solid #c2c3c4;
      border-radius: 4px;
      padding: 0 10px;
      margin: 0 -10px;
      margin-bottom: 5px;
    }
    .addLimit {
      cursor: pointer;
      text-align: center;
      color: #409EFF;
      margin: 8px 0 10px 0;
    }
    .el-form-item__content {
      >i {
        cursor: pointer;
        &.el-icon-minus {
          padding-left: 5px;
        }
      }
      .select-type {
        width: 100%;
      }
      .rule-content {
        margin-top: 5px;
      }
    }
    .limit-transition-enter{
      transform: translateY(-120px);
    }
    .limit-transition-leave-to{
      opacity: 0;
    }
    .limit-transition-enter-active,.limit-transition-leave-active{
      transition: all .3s ease-out;
    }
    .limit-transition-leave-active{
      position: absolute;
    }
    .limit-transition-move {
      transition: transform .3s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/limit.vue